import { ISideMenuCategoryLang } from '../../../types/lang'

export const sideMenuCategoryLang: ISideMenuCategoryLang = {
	side_menu_category: {
		affiliate_title: 'Affiliate_ua',
		revenue_title: 'Revenue_ua',
		profile_title: 'PROFILE_ua',
	}
}